import React from "react";
import ImgHeader from "../ImgHeader";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import { H1 } from "../Headers";
import WithHelperBar from "../WithHelperBar";
import { Stepper, Step, StepLabel, StepContent } from "@material-ui/core";
import styled from "styled-components";
import getBadge from "./getBadge";
import Theme from "../../Theme";
import getUrl from "../../functions/getUrl";
import fetchJson from "../../functions/fetchJson";
import ITier from "../../models/ITier";
import fromMarkdown from "../../functions/fromMarkdown";

const LegalNote = styled.em`
  display: block;
  font-size: 10px;
  line-height: 14px;

  &::before {
    content: "*";
    color: ${Theme.colors.error};
    margin-right: 5px;
  }
`;

export default () => {
  const [tiers, setTiers] = React.useState<ITier[] | undefined>();
  React.useEffect(fetchJson(getUrl("/content/tiers.json"), setTiers), []);

  return (
    <>
      <ScrollToTopOnMount />
      <ImgHeader url="/static/img/PartnershipTiers.jpg" shadowOpacity={0.4}>
        <H1>Partnership Tiers</H1>
      </ImgHeader>
      <WithHelperBar>
        {fromMarkdown("content/tiers.md", 3)}
        <Stepper orientation="vertical">
          {tiers &&
            tiers.map(tier => (
              <Step active={true}>
                <StepLabel StepIconComponent={getBadge(tier.type)}>{tier.name}</StepLabel>
                <StepContent>{tier.description}</StepContent>
              </Step>
            ))}
        </Stepper>
        <LegalNote>
          Full explanation and categorizing of a business partner relationship including any associated costs can be obtained from Skyward’s Vice President of
          New Business Development who oversees the Skyward partner program.
        </LegalNote>
      </WithHelperBar>
    </>
  );
};
